import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./components.css";
import { BrowserRouter as Router, Route, Routes, BrowserRouter } from "react-router-dom";
import TagManager from "react-gtm-module";

import {
  Navigation,
  Footer,
  Home,
  Provider,
  NurseTechnician,
  SupplyChain,
  Information,
  FixedTab,

} from "./components";

const tagManagerArgs = {
  gtmId: 'GTM-WZBG674'
}

TagManager.initialize(tagManagerArgs)

ReactDOM.render(
  <BrowserRouter basename="/usa/en/product-areas/vascular-access/central-access/power-of-chlorhexidine">
    <Navigation />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/index.html" element={<Home />} />
      <Route path="/provider" element={<Provider />} />
      <Route path="/nurse-technician" element={<NurseTechnician />} />
      <Route path="/supply-chain" element={<SupplyChain />} />
      <Route path="/information" element={<Information />} />
    </Routes>
    {/* <Popup /> */}
    <FixedTab />
    <Footer />
  </BrowserRouter>,

  document.getElementById("root")
);
